import { toast } from "sonner";
import { api } from "@/lib/api";

const FALLBACK = "Evrak görüntülenemedi. Google Drive erişimini veya dosya bağlantısını kontrol edin.";

/**
 * Evrakı yeni sekmede açar. Sekme, açılır pencere engeline takılmamak için
 * doğrudan tıklama olayı içinde senkron açılır; bağlantı Drive API'den doğrulanır.
 */
export const openDocument = async ({ taskId, fileId } = {}) => {
  const tab = window.open("", "_blank");
  try {
    const { data } = await api.get("/documents/link", {
      params: taskId ? { task_id: taskId } : { file_id: fileId },
    });
    if (!data?.view_link) throw new Error("link yok");
    if (tab) tab.location.href = data.view_link;
    else window.location.href = data.view_link;
  } catch (e) {
    if (tab && !tab.closed) tab.close();
    // Sunucudan gelen açıklayıcı hata gösterilir (dosya yok / yetki yok / oturum / klasör / sunucu)
    toast.error(e.response?.data?.detail || FALLBACK, { id: "document-error", duration: 9000 });
  }
};
